import angular from 'angular';
import uiRouter from 'angular-ui-router';
import heatmapDirective from './heatmap.component';
import 'cal-heatmap/cal-heatmap.css';

// this isn't a component, cause we're manipulating the DOM, and for that, we need
// the link function.  components don't have that, so we use a directive.
let heatmapModule = angular.module('heatmap', [])

.directive('heatmap', () => new heatmapDirective);

export default heatmapModule;



// WEBPACK FOOTER //
// ./client/common/directives/heatmap/heatmap.js